import React from 'react';
import PropTypes from 'prop-types';
import Paper from '@mui/material/Paper';
import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';
import IconButton from '@mui/material/IconButton';
import Avatar from '@mui/material/Avatar';
import UnfoldMoreIcon from '@mui/icons-material/UnfoldMore';

function AccountPickerTrigger({ currentUser = undefined, onOpenMenu, theme }) {
	const firstName = (currentUser?.firstName || '').trim();
	const lastName = (currentUser?.lastName || '').trim();
	const firstInitial = firstName.charAt(0).toUpperCase();
	const lastInitial = lastName.charAt(0).toUpperCase();
	const fullName = [firstName, lastName].filter(Boolean).join(' ');

	const styles = {
		paper: {
			p: '0 .15rem',
			display: 'flex',
			alignItems: 'center',
			columnGap: theme.spacing(1),
			color: theme.palette.base.contrastText,
			backgroundColor: theme.palette.base.light,
		},
		name: {
			m: '1rem 0',
			display: { xs: 'none', md: 'flex' },
			alignItems: 'center',
			justifyContent: 'center',
			fontSize: theme.palette.textSize.sizeSm,
		},
		iconButton: {
			display: { xs: 'none', md: 'flex' },
			color: theme.palette.base.contrastText,
		},
	};

	return (
		<Paper
			component="form"
			onClick={onOpenMenu}
			sx={styles.paper}
			elevation={0}
		>
			<Avatar
				className="userAvatarName-desktop"
				role="button"
				fontSize={theme.palette.textSize.sizeSm}
			>
				{firstInitial}
				{lastInitial}
			</Avatar>

			<Typography className="userFullName-desktop" sx={styles.name}>
				<Box
					component="span"
					fontSize={theme.palette.textSize.sizeSm}
					fontWeight={theme.palette.fontWeight.bold}
				>
					{fullName}
				</Box>
			</Typography>

			<IconButton aria-label="directions" sx={styles.iconButton}>
				<UnfoldMoreIcon
					fontSize="small"
					role="graphics-symbol"
					aria-hidden="true"
				/>
			</IconButton>
		</Paper>
	);
}

AccountPickerTrigger.propTypes = {
	currentUser: PropTypes.shape({
		firstName: PropTypes.string,
		lastName: PropTypes.string,
	}),
	onOpenMenu: PropTypes.func.isRequired,
	theme: PropTypes.object.isRequired,
};

export default AccountPickerTrigger;
